import { Link } from 'react-router';
import { Footer, TopBar, useDocumentTitle } from '../../components/Chrome';
import { GAMES } from './info';

export function GamesHub() {
  useDocumentTitle('Party games');
  return (
    <>
      <TopBar />
      <main className="page stack">
        <section>
          <h1 style={{ marginBottom: 4 }}>Party games</h1>
          <p className="muted" style={{ margin: 0 }}>
            Four games for one phone and a room full of family. No sign-up and no room code.
          </p>
        </section>

        <div className="mg-hub">
          {GAMES.map((g) => (
            <article key={g.key} className={`mg-tile ${g.key}`}>
              <Link to={g.path} className="mg-tile-main">
                <span className="mg-emoji" aria-hidden="true">
                  {g.emoji}
                </span>
                <span className="stack" style={{ gap: 2 }}>
                  <strong className="name">{g.name}</strong>
                  <span className="tagline">{g.tagline}</span>
                  <span className="players">{g.players}</span>
                </span>
              </Link>
              <details className="mg-tile-rules">
                <summary>How to play</summary>
                <ol>
                  {g.rules.map((r) => (
                    <li key={r}>{r}</li>
                  ))}
                </ol>
              </details>
              <Link to={g.path} className="btn btn-primary btn-block">
                Play {g.key === 'one-phone' ? 'on one phone' : g.name}
              </Link>
            </article>
          ))}
        </div>

        <p className="muted small center" style={{ margin: 0 }}>
          Everyone has their own phone and some Wi-Fi? <Link to="/">Start a room</Link> and play the full game together.
        </p>
      </main>
      <Footer />
    </>
  );
}
